import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-sales-order-eft-request-dialog',
  templateUrl: './sales-order-eft-request-dialog.component.html',
  styleUrls: ['./sales-order-eft-request-dialog.component.scss']
})
export class SalesOrderEftRequestDialogComponent implements OnInit {
  salesOrder = {
    salesOrderNumber: '',
    totalAmount: 0,
    depositRequired: 0,
    depositReceived: '',
    depositOutstanding: 0,
    customerCode: '',
    customerAccountBalance: 0
  };
  stores: any[] = [];
  banks: any[] = [];
  form: FormGroup;
  refundReasons:{
    refundReasonId: number;
    refundReasonDesc: string;
  }[] = [];

  constructor(
    public dialogRef: MatDialogRef<SalesOrderEftRequestDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private fb: FormBuilder
  ) {
    this.salesOrder = data;
    this.form = fb.group({
      salesOrderNumber: [null, Validators.compose([Validators.required])],
      storeId: [null, Validators.compose([Validators.required])],
      amount: [null],
      bank: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
      branchCode: [null, Validators.compose([Validators.minLength(1), Validators.maxLength(10)])],
      accountNumber: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(20)])],
      refundReasonId: [null, Validators.compose([Validators.required])],
      comment: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(200)])],
    });
  }

  ngOnInit() {
    this.form.controls['salesOrderNumber'].setValue(this.salesOrder.salesOrderNumber);
    this.form.controls['amount'].setValue(0);
    this.form.controls['amount'].setValidators([Validators.required, Validators.min(1), Validators.max(this.salesOrder.depositOutstanding * -1)]);

    this.baseService.executeCommand<any>('portal_syspro_order_eft_request_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores;
          this.banks = response.data.banks;
          this.refundReasons = response.data.refundReasons || [];
          if (this.stores && this.stores.length === 1) {
            this.form.controls['storeId'].setValue(this.stores[0].storeId);
          }
          if (this.banks && this.banks.length === 1) {
            this.form.controls['bank'].setValue(this.banks[0].bank);
          }
          if (this.refundReasons && this.refundReasons.length === 1) {
            this.form.controls['refundReasonId'].setValue(this.refundReasons[0].refundReasonId);
          }
        }
      });
  }

  save() {
    this.dialogRef.close(this.form.value);
  }

  amountTenderedChanged() {
    // const amount = +this.form.value.amount || 0;
    // this.form.controls['amount'].setValue(+amount.toFixed(2));
  }

  amountTenderedFocusOut() {
    const amount = +this.form.value.amount || 0;
    this.form.controls['amount'].setValue(+amount.toFixed(2));
  }

  onBankSelectionChange(event: any) {
    this.form.controls['bank'].setValue(event.value.bank);
    this.form.controls['branchCode'].setValue(event.value.branchCode);

    this.form.updateValueAndValidity({onlySelf: false});
}
}
